var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33161_30555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 26.6667C14.6667 27.0203 14.8071 27.3594 15.0572 27.6095C15.3072 27.8595 15.6464 28 16 28C16.3536 28 16.6928 27.8595 16.9428 27.6095C17.1929 27.3594 17.3333 27.0203 17.3333 26.6667V17.3333H26.6667C27.0203 17.3333 27.3594 17.1929 27.6095 16.9428C27.8595 16.6928 28 16.3536 28 16C28 15.6464 27.8595 15.3072 27.6095 15.0572C27.3594 14.8071 27.0203 14.6667 26.6667 14.6667H17.3333V5.33333C17.3333 4.97971 17.1929 4.64057 16.9428 4.39052C16.6928 4.14048 16.3536 4 16 4C15.6464 4 15.3072 4.14048 15.0572 4.39052C14.8071 4.64057 14.6667 4.97971 14.6667 5.33333V14.6667H5.33333C4.97971 14.6667 4.64057 14.8071 4.39052 15.0572C4.14048 15.3072 4 15.6464 4 16C4 16.3536 4.14048 16.6928 4.39052 16.9428C4.64057 17.1929 4.97971 17.3333 5.33333 17.3333H14.6667V26.6667Z",
    fill: "#FF8C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33161_30555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOrange);
export default __webpack_public_path__ + "static/media/plus-orange.88e97b6c711eac2f2a5dadf3871c4c17.svg";
export { ForwardRef as ReactComponent };